import { render, staticRenderFns } from "./FeedbackPop.vue?vue&type=template&id=ec168fde&scoped=true&"
import script from "./FeedbackPop.vue?vue&type=script&lang=js&"
export * from "./FeedbackPop.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackPop.vue?vue&type=style&index=0&id=ec168fde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec168fde",
  null
  
)

export default component.exports